import { Injectable } from '@angular/core';
import { AuthService } from './auth/auth.service';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FilaPendencia } from 'src/app/models/usuario'

@Injectable({
  providedIn: 'root'
})
export class PendenciasService {

  constructor(
    private auth: AuthService,
    private firestore: AngularFirestore
  ) { }

  /**
   * Retorna se um usuário tem pendências no firestore
   * @returns 
   */
   get checaFilaPendencia(): Observable<Boolean>{
    
    let uid = this.auth.user.uid;
    
    return this.firestore.collection("filaPendenciasUsu")
      .doc(uid)
      .valueChanges()
      .pipe(map(doc => {
        if (doc && doc['documentos']){          
          return doc['documentos'].length > 0
        }
        return;
      }))
  }

  
  /**
   * Retorna as pendências do usuário na fila de pendências
   */
  get listaPendencias():Observable<any>{

    let uid = this.auth.user.uid;

    return this.firestore.collection("filaPendenciasUsu")
      .doc(uid)
      .get();        
  }

  
  /**
   * Traduz o tipo para uma mensagem mais amigável para o usuário
   * @param tipo 
   * @returns 
   */
  traduzTipo(tipo:string):string{

    switch (tipo){      
      
      case "compartilhamento_dados":{
        return "Compartilhamento de dados";
      }

      default:{
        return "mensagem não traduzida"
      }
    }
  }
}
